export default __webpack_public_path__ + "static/do-leading-visual-44a4a5e0a60dfea7a6f65cc7b37b9427.png";